import { Delete } from "@mui/icons-material";
import { Card, Grid, styled, SvgIcon, Typography } from "@mui/material";
import FormikAutocomplete from "../commons/formik/FormikAutocomplete";

export const StyledResponsables = {
    Icon: styled("div")(({ theme }) => ({
        marginRight: 10,
    })),
    TableFooter: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        margin: "30px 25px 0px 0px",
        "& button": {
            marginLeft: 10,
        },
    })),
    TableCell: styled("div")(({ theme }) => ({
        overflowWrap: "break-word",
    })),
    MessageContainer: styled("div")(({ theme }) => ({
        minHeight: 150,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
};

export const StyledResponsablesTable = {
    Icon: styled(Delete)(({ theme }) => ({
        marginLeft: 10,
        cursor: "pointer",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        margin: "10px 0px",
        "& button": {
            marginLeft: 10,
        },
    })),
    TableCell: styled("div")(({ theme }) => ({
        overflowWrap: "break-word",
    })),
    MessageContainer: styled("div")(({ theme }) => ({
        minHeight: 150,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
}

export const StyledResponsableDialog = {
    RowContainer: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        padding: 10,
    })),
    InputContainer: styled("div")(({ theme }) => ({
        flex: 1,
    })),
    Input: styled(FormikAutocomplete)(({ theme }) => ({
        flex: 1,
    })),
    RightInput: styled("div")(({ theme }) => ({
        marginLeft: 20,
    })),
    DialogContainer: styled("div")(({ theme }) => ({
        minHeight: 180,
        minWidth: 600,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
    Loading: styled("div")(({ theme }) => ({
        marginTop: 40,
        marginBottom: 80,
    })),
}

export const StyledResponsablesCard = {
    IconAligned: styled(Grid)(() => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    })),
    Title: styled(Typography)(() => ({
        paddingBottom: "10px",
    })),
    Icon: styled(SvgIcon)(() => ({
        color: "white"
    })),
    Card: styled(Card)(() => ({
        padding: '20px',
    }))
}